<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="110px">
        <el-form-item label="视频类型">
          <el-select v-model="editData.videotype" placeholder="请选择" class="select">
            <el-option
              v-for="item in learnvideoList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频标题" class="addAdminForm">
          <el-input v-model="editData.title" placeholder="请输入视频标题"></el-input>
        </el-form-item>
        <el-form-item label="视频封面" class="addAdminForm">
          <el-input v-model="editData.cover" placeholder="请输入视频封面"></el-input>
        </el-form-item>
        <el-form-item label="视频轮播图" class="addAdminForm">
          <el-input v-model="editData.pic" placeholder="请输入视频轮播图"></el-input>
        </el-form-item>
        <el-form-item label="视频时长" class="addAdminForm">
          <el-input v-model="editData.length" placeholder="请输入视频时长,单位秒"></el-input>
        </el-form-item>
        <el-form-item label="观看次数" class="addAdminForm">
          <el-input v-model="editData.num" placeholder="请输入观看次数"></el-input>
        </el-form-item>
        <el-form-item label="来源图标" class="addAdminForm">
          <el-input v-model="editData.fromlogo" placeholder="请输入来源图标"></el-input>
        </el-form-item>
        <el-form-item label="来源名称" class="addAdminForm">
          <el-input v-model="editData.fromname" placeholder="请输入来源名称"></el-input>
        </el-form-item>
        <el-form-item label="视频网址" class="addAdminForm">
          <el-input v-model="editData.url" placeholder="请输入视频网址"></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      learnvideoList: [],
      editData: {
        id: '0',
        videotype: '',
        title: '',
        cover: '',
        pic: '',
        length: '',
        num: '',
        fromlogo: '',
        fromname: '',
        url: ''
      }
    }
  },
  mounted () {
    this.learnvideoList = Vue.prototype.FunGetLearnVideo()
  },
  methods: {
    LoadData (row) {
      this.editData.id = row.Id
      this.editData.videotype = row.Videotype.toString()
      this.editData.title = row.Title
      this.editData.cover = row.Cover
      this.editData.pic = row.Pic
      this.editData.length = row.Length
      this.editData.num = row.Num
      this.editData.fromlogo = row.Fromlogo
      this.editData.fromname = row.Fromname
      this.editData.url = row.Url
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.EditKgjtWebsiteLearnVideo()
    },
    EditKgjtWebsiteLearnVideo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        videotype: that.editData.videotype,
        title: that.editData.title,
        cover: that.editData.cover,
        pic: that.editData.pic,
        length: that.editData.length,
        num: that.editData.num,
        fromlogo: that.editData.fromlogo,
        fromname: that.editData.fromname,
        url: that.editData.url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteLearnVideo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
